/* AUTH */
export const SEARCH_CATEGORY_CHANGE = 'SEARCH_CATEGORY_CHANGE';
export const SEARCH_CATEGORY_CHANGE_SUCCESS = 'SEARCH_CATEGORY_CHANGE_SUCCESS';
export const SEARCH_CATEGORY_CHANGE_FAILED = 'SEARCH_CATEGORY_CHANGE_FAILED';

export const SEARCH_KEY_CHANGE = 'SEARCH_KEY_CHANGE';
export const SEARCH_KEY_CHANGE_SUCCESS = 'SEARCH_KEY_CHANGE_SUCCESS';
export const SEARCH_KEY_CHANGE_FAILED = 'SEARCH_KEY_CHANGE_FAILED';

export const SEARCH = 'SEARCH';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILED = 'SEARCH_FAILED';

export const REQUEST_FRIENDSHIP = 'REQUEST_FRIENDSHIP';
export const REQUEST_FRIENDSHIP_SUCCESS = 'REQUEST_FRIENDSHIP_SUCCESS';
export const REQUEST_FRIENDSHIP_FAILED = 'REQUEST_FRIENDSHIP_FAILED';

export const DELETE_FRIENDSHIP_REQUEST = 'DELETE_FRIENDSHIP_REQUEST';
export const DELETE_FRIENDSHIP_REQUEST_SUCCESS = 'DELETE_FRIENDSHIP_REQUEST_SUCCESS';
export const DELETE_FRIENDSHIP_REQUEST_FAILED = 'DELETE_FRIENDSHIP_REQUEST_FAILED';

export const PATCH_FRIENDSHIP_REQUEST = 'PATCH_FRIENDSHIP_REQUEST';
export const PATCH_FRIENDSHIP_REQUEST_SUCCESS = 'PATCH_FRIENDSHIP_REQUEST_SUCCESS';
export const PATCH_FRIENDSHIP_REQUEST_FAILED = 'PATCH_FRIENDSHIP_REQUEST_FAILED';

export const CHARTS = 'CHARTS';
export const CHARTS_SUCCESS = 'CHARTS_SUCCESS';
export const CHARTS_FAILED = 'CHARTS_FAILED';

export const SHARE = 'SHARE';
export const SHARE_SUCCESS = 'SHARE_SUCCESS';
export const SHARE_FAILED = 'SHARE_FAILED';

